<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()" v-if="shouldShowBanner">
    <div :class="b('content')">
      <span :class="b('icon')" v-html="displayedIcons.info"></span>

      <p :class="b('text')">
        {{ $t("Перед началом работы пройдите процедуру") }}
        <span @click="goToVerification" :class="b('highlight')">{{
          $t("KYC")
        }}</span>
        {{ $t("и добавьте") }}
        <span @click="goToSettings" :class="b('highlight')">{{
          $t("реквизиты")
        }}</span>
        {{ $t("своих компаний в избранное") }}
      </p>
    </div>
  </div>
</template>
